import { Shield, GraduationCap, Crown, BookOpen, Brain, Headphones } from "lucide-react";

export const ANNUAL_DISCOUNT = 15;

export type PlanDef = {
  id: string;
  name: string;
  subtitle: string;
  icon: any;
  monthlyPrice: number;
  features: string[];
  color: string;
  popular: boolean;
  badge?: string;
};

export type AddOnDef = {
  id: string;
  name: string;
  description: string;
  icon: any;
  monthlyPrice: number;
  features: string[];
  includedIn: string[];
};

export const plans: PlanDef[] = [
  {
    id: "basic",
    name: "النظام الإداري",
    subtitle: "Starter 🟢",
    icon: Shield,
    monthlyPrice: 1000,
    features: [
      "إدارة الموظفين (حضور، غياب، رواتب)",
      "إدارة الأطفال (تسجيل، بيانات، متابعة)",
      "إدارة الفصول والجداول الدراسية",
      "تقارير إدارية ومالية",
      "تطبيق أولياء الأمور الأساسي",
      "دعم بالبريد الإلكتروني",
    ],
    color: "border-primary",
    popular: false,
    badge: "الأساس",
  },
  {
    id: "standard",
    name: "إداري + تعليمي",
    subtitle: "Growth 🟡",
    icon: GraduationCap,
    monthlyPrice: 2000,
    features: [
      "كل مميزات النظام الإداري",
      "مكتبة دروس (PDF، فيديو، نصوص)",
      "تحويل النصوص لامتحانات أوتوماتيك",
      "واجبات مع رفع صور الكراسة وتصحيح أونلاين",
      "جلسات فيديو لايف (بث مباشر)",
      "ألعاب تعليمية ودروس تفاعلية",
      "دعم بالواتساب",
    ],
    color: "border-blue-500",
    popular: true,
    badge: "إداري + تعليمي",
  },
  {
    id: "premium",
    name: "النظام الكامل",
    subtitle: "Pro 🔵",
    icon: Crown,
    monthlyPrice: 3500,
    features: [
      "كل مميزات الإداري + التعليمي",
      "تخصيص الهوية البصرية (شعار، ألوان)",
      "تقارير متقدمة بالذكاء الاصطناعي",
      "مكتبة موارد تعليمية جاهزة",
      "دعم فني مميز وكول سنتر خاص",
      "API مخصص",
      "مدير حساب خاص",
    ],
    color: "border-yellow-500",
    popular: false,
    badge: "حل متكامل",
  },
];

export const addOns: AddOnDef[] = [
  {
    id: "educational",
    name: "الإضافة التعليمية",
    description: "أضف النظام التعليمي الكامل لباقتك الإدارية",
    icon: BookOpen,
    monthlyPrice: 1500,
    features: [
      "مكتبة دروس متعددة الوسائط",
      "امتحانات تلقائية من النصوص",
      "واجبات وتصحيح أونلاين",
      "جلسات بث مباشر",
      "ألعاب تعليمية تفاعلية",
    ],
    includedIn: ["standard", "premium"],
  },
  {
    id: "ai_reports",
    name: "تقارير الذكاء الاصطناعي",
    description: "تحليل أداء الأطفال وتقارير ذكية متقدمة",
    icon: Brain,
    monthlyPrice: 500,
    features: [
      "تحليل أداء كل طفل",
      "توصيات تعليمية مخصصة",
      "تقارير شهرية تلقائية",
    ],
    includedIn: ["premium"],
  },
  {
    id: "priority_support",
    name: "دعم فني مميز",
    description: "دعم أولوية مع كول سنتر خاص 24/7",
    icon: Headphones,
    monthlyPrice: 500,
    features: [
      "دعم أولوية 24/7",
      "كول سنتر مخصص",
      "مدير حساب شخصي",
    ],
    includedIn: ["premium"],
  },
];
